module.exports = __webpack_public_path__ + "static/media/JavaImg.d9fa5fbf.png";